import { Button } from "components/atoms/Button";
import { Header } from "components/atoms/Typography";
import EmptySidebarView from "pages/BuildingPage/BuildingSidebar/EmptySidebarView";
import posthog from "posthog-js";

interface AddEquipmentPromptProps {
    onClickAdd: () => void;
    onClickSingleForm: () => void;
}

function AddEquipmentPrompt({ onClickAdd, onClickSingleForm }: AddEquipmentPromptProps) {
    return (
        <>
            <EmptySidebarView />
            <div className="building-equipment-sidebar__empty-view">
                <Header size="small" style={{ lineHeight: "1.5rem" }}>
                    Add equipment information to improve baseline & recommendations
                </Header>
                <div className="building-equipment-sidebar__empty-view-actions">
                    <Button
                        id="add-equipment-button"
                        type="primary"
                        onClick={() => {
                            onClickAdd();
                            posthog.capture("Add-equipment started");
                        }}
                    >
                        Start Wizard
                    </Button>
                    <Button type="primary" onClick={onClickSingleForm} dataTestId="open-single-form-survey-empty-state">
                        Use Form
                    </Button>
                </div>
            </div>
        </>
    );
}

export default AddEquipmentPrompt;
